export default __webpack_public_path__ + "static/media/login.b1625549.png";